export default __webpack_public_path__ + "static/media/Stone-3.78b7db33.gif";